<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter05">
<a id="page5">
</a><div class="chapterHead"><a id="page5">
</a><h2 class="chapterTitle"><a id="page5"><span class="xrefInternal"></span></a><a href="#/004TOC#chapter_05"><span class="bold">BUT NOW–I’LL NEVER BE PREGNANT AGAIN</span></a></h2></div>
<div class="chapterBody">
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">My biological clock</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">has ticked its last tock.</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">And the finality of this fact,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">the that’s-thatness of it,</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">hollows me</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">like a gutted pumpkin</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">and leaves me</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">with a sense of loss so deep</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">that all I want to do</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">is sleep.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009-chapter05.vue?5e38a300